import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  label: string
  hint?: string
  error?: string
  required?: boolean
  children: ReactNode
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, hint, error, required, id, className = '', children, ...rest },
  ref,
) {
  const selectId = id ?? `al-select-${Math.random().toString(36).slice(2, 10)}`
  const describedBy = error ? `${selectId}-err` : hint ? `${selectId}-hint` : undefined
  return (
    <div className={`m-bx3 al-field ${error ? 'al-field--error' : ''}`}>
      <LabelPrimitive.Root htmlFor={selectId} className="al-field__label">
        {label}
        {required ? (
          <>
            {' '}
            <span className="al-field__required" aria-hidden="true">
              *
            </span>
          </>
        ) : null}
      </LabelPrimitive.Root>
      <div className="dropdown">
        <select
          ref={ref}
          id={selectId}
          className={className}
          aria-invalid={error ? true : undefined}
          aria-required={required ? true : undefined}
          aria-describedby={describedBy}
          {...rest}
        >
          {children}
        </select>
      </div>
      {error ? (
        <p id={`${selectId}-err`} role="alert" className="al-field__error xsmall">
          {error}
        </p>
      ) : hint ? (
        <p id={`${selectId}-hint`} className="al-field__hint">
          {hint}
        </p>
      ) : null}
    </div>
  )
})
